"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _OptionTypes = require("UIComponents/types/OptionTypes");

var _react = _interopRequireWildcard(require("react"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  options: _react.PropTypes.arrayOf(_OptionTypes.OptionType.isRequired),
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string.isRequired)])
};
var defaultProps = {
  options: []
};

var ReferenceInputEnumNone =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ReferenceInputEnumNone, _Component);

  function ReferenceInputEnumNone() {
    (0, _classCallCheck2.default)(this, ReferenceInputEnumNone);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReferenceInputEnumNone).apply(this, arguments));
  }

  (0, _createClass2.default)(ReferenceInputEnumNone, [{
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["options"]);
      return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, rest, {
        options: options,
        ref: "input"
      }));
    }
  }]);
  return ReferenceInputEnumNone;
}(_react.Component);

exports.default = ReferenceInputEnumNone;
ReferenceInputEnumNone.propTypes = propTypes;
ReferenceInputEnumNone.defaultProps = defaultProps;
module.exports = exports.default;